<template>
  <div>
  <input-base
      ref="base"
      :read-only="readOnly"
      :validated-field="validatedField"
      :field-config="fieldConfig"
      :editor-mode="editorMode"
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
      :can-translate="true"
      :mode="mode"
  >
    <template slot="editor">
      <textarea
          v-if="editorStyle==='simple'"
          :class="readOnly ? 'form-control grey-label w-100 p-2' : 'w-100 p-2'"
          :readonly="readOnly"
          :disabled="readOnly"
          v-model="validatedField.value"
          :maxlength="fieldConfig.maxLength"
          style="border-color: #ced4da; "
          @focusout="focusOut"
          ref="input"
      >
      </textarea> <div
        v-else style="font-family: lucida,courier,monospace; font-size:11px; min-width:100%">
      <prism-editor

          :readonly="readOnly"
          ref="editor"
          class="my-editor"
          v-model="validatedField.value"
          :highlight="highlighter"
          line-numbers

          style="white-space: nowrap; "
      ></prism-editor>
    </div>
    </template>
  </input-base>
  </div>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import InputBase from "@/components/inputs/InputBase";
import {PrismEditor} from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";

import Prismjs from "prismjs";
import "prismjs/components/prism-velocity";
// import "prismjs/components/prism-http";
// import "prismjs/components/prism-json";
// import "prismjs/components/prism-excel-formula";

export default {
  name: "MultiLineTextRenderer",
  components: {InputBase, ReachInput, PrismEditor},

  mounted() {
    this.editorStyle = this.fieldConfig.codeStyle;
    if (this.fieldConfig.autofocus) {
      let canInitialFocus = true;
      if (this.validatedField?.validatedForm?.formConfig?.onlyEmbedded) {
        canInitialFocus = false;
      }
      if (canInitialFocus) {
        setTimeout(() => this.afterMounted(), 200);
      }
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: TextFormFieldConfig, required: true},
    openFromGrid: {default: false},
    gridEditor: {default: null},
    mode: {default: null},
  },

  methods: {

    focusOut() {
      this.validatedField?.validate();
    },

    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    afterMounted() {
      if (!this.readOnly) {
        if (this.$refs.input) {
          const el = this.$refs.input;
          el.focus();
          el.setSelectionRange(el.value.length, el.value.length);
        } else if (this.$refs.editor) {
          const el = this.$refs.input;
          el.focus();
          el.setSelectionRange(el.value.length, el.value.length);
        }
      }
    },

    setEditorMode(val) {
      this.editorMode = val;
    },
    highlighter(code) {
      return highlight(code, Prismjs.languages.velocity, 'velocity'); // languages.<insert language> to return html with markup
//    return highlight(code, dummy);
    },
  },


  data: () => ({
    editorStyle: "simple",
    highlight: 'velocity',
    readOnly: true,
    editorMode: false,
  })
}
</script>

<style scoped>

</style>